import { createUseStyles, useTheme } from 'react-jss'
import {
  TypographyElement
} from 'UI'
import styles from './style'

const useStyles = createUseStyles(styles)

export default ({ handleClick, title, path, margin = 0, dataTest, active }) => {
  const { link, text } = useStyles({ margin })
  const theme = useTheme()
  return (
    <div
      className={link}
      onClick={() => handleClick()}
      data-test={dataTest}
    >
      <TypographyElement
        variant='body1'
        className={text}
        display='inline-flex'
        align='center'
        Component='a'
        href={path}
        handleClick={e => e.preventDefault()}
        color={active ? theme.primary[0] : null}
      >
        {title}
      </TypographyElement>
    </div>
  )
}
